import axios from 'axios';

const TOKEN_KEY = 'tencent_admin_token';

export function getAdminToken() {
  try {
    return sessionStorage.getItem(TOKEN_KEY) || '';
  } catch (e) {
    return '';
  }
}

export function setAdminToken(token) {
  try {
    if (token) sessionStorage.setItem(TOKEN_KEY, token);
    else sessionStorage.removeItem(TOKEN_KEY);
  } catch (e) {
    /* ignore */
  }
}

const client = axios.create({ baseURL: '/api/admin' });

client.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function adminLogin(username, password) {
  const res = await client.post('/auth/login', { username, password });
  if (res.data && res.data.ok && res.data.token) {
    setAdminToken(res.data.token);
  }
  return res.data;
}

export async function adminSession() {
  const res = await client.get('/session');
  return res.data;
}

export function adminLogout() {
  setAdminToken('');
}

export function getAdminApiError(err, fallback = '操作失败') {
  const msg = err && err.response && err.response.data && err.response.data.error;
  return msg || fallback;
}

export async function getSystemConfig() {
  const res = await client.get('/tables/system-config');
  return res.data;
}

export async function putSystemConfig(body) {
  const res = await client.put('/tables/system-config', body);
  return res.data;
}

export async function getAgencyTabs() {
  const res = await client.get('/tables/home-agency-tabs');
  return res.data;
}

export async function putAgencyTabs(body) {
  const res = await client.put('/tables/home-agency-tabs', body);
  return res.data;
}

export async function getCacheMeta() {
  const res = await client.get('/tables/cache-meta');
  return res.data;
}

export async function listSolicitations(params) {
  const res = await client.get('/solicitations', { params });
  return res.data;
}

export async function patchSolicitation(id, body) {
  const res = await client.patch(`/solicitations/${id}`, body);
  return res.data;
}

export async function listUserFeedbacks(params) {
  const res = await client.get('/user-feedbacks', { params });
  return res.data;
}

export async function patchUserFeedback(id, body) {
  const res = await client.patch(`/user-feedbacks/${id}`, body);
  return res.data;
}

export async function getProductPerformanceAgents() {
  const res = await client.get('/reports/product-performance/agents');
  return res.data;
}

export async function getProductPerformanceProducts(agent) {
  const res = await client.get('/reports/product-performance/products', { params: { agent } });
  return res.data;
}

export async function runProductPerformanceReport(body) {
  const res = await client.post('/reports/product-performance/run', body);
  return res.data;
}

export async function getProductPerformanceRun(id) {
  const res = await client.get(`/reports/product-performance/runs/${id}`);
  return res.data;
}

export async function listProductPerformanceRuns(limit = 10) {
  const res = await client.get('/reports/product-performance/runs', { params: { limit } });
  return res.data;
}

export async function deleteProductPerformanceRun(id) {
  const res = await client.delete(`/reports/product-performance/runs/${id}`);
  return res.data;
}

export async function listPortalUsers() {
  const res = await client.get('/portal-users');
  return res.data;
}

export async function listPortalUserLoginLogs(id) {
  const res = await client.get(`/portal-users/${id}/login-logs`);
  return res.data;
}

export async function createPortalUser(body) {
  const res = await client.post('/portal-users', body);
  return res.data;
}

export async function patchPortalUser(id, body) {
  const res = await client.patch(`/portal-users/${id}`, body);
  return res.data;
}

export async function listMpVipMembers(params) {
  const res = await client.get('/mp-vip/members', { params });
  return res.data;
}

export async function upsertMpVipMember(openid, body) {
  const res = await client.put(`/mp-vip/members/${encodeURIComponent(openid)}`, body);
  return res.data;
}

export async function listMpBlocklist(params) {
  const res = await client.get('/mp-access/blocklist', { params });
  return res.data;
}

export async function upsertMpBlock(openid, body) {
  const res = await client.put(`/mp-access/blocklist/${encodeURIComponent(openid)}`, body);
  return res.data;
}

export async function deleteMpBlock(openid) {
  const res = await client.delete(`/mp-access/blocklist/${encodeURIComponent(openid)}`);
  return res.data;
}

export async function fetchProductPerformancePreviewHtml(filename) {
  const res = await client.get(`/reports/product-performance/preview/${encodeURIComponent(filename)}`, {
    responseType: 'text'
  });
  return res.data;
}

export async function getRecentProductPerformanceAgents() {
  const res = await client.get('/reports/recent-product-performance/agents');
  return res.data;
}

export async function getRecentProductPerformanceProducts(agent) {
  const res = await client.get('/reports/recent-product-performance/products', { params: { agent } });
  return res.data;
}

export async function runRecentProductPerformanceReport(body) {
  const res = await client.post('/reports/recent-product-performance/run', body);
  return res.data;
}

export async function getRecentProductPerformanceRun(id) {
  const res = await client.get(`/reports/recent-product-performance/runs/${id}`);
  return res.data;
}

export async function listRecentProductPerformanceRuns(limit = 10) {
  const res = await client.get('/reports/recent-product-performance/runs', { params: { limit } });
  return res.data;
}

export async function deleteRecentProductPerformanceRun(id) {
  const res = await client.delete(`/reports/recent-product-performance/runs/${id}`);
  return res.data;
}

export async function fetchRecentProductPerformancePreviewHtml(filename) {
  const res = await client.get(`/reports/recent-product-performance/preview/${encodeURIComponent(filename)}`, {
    responseType: 'text'
  });
  return res.data;
}

export async function fetchBondBarometerSummary(params) {
  const res = await client.get('/bond-barometer/summary', { params });
  return res.data;
}

export async function getAuthRouting() {
  const res = await client.get('/auth-routing');
  return res.data;
}

export async function putAuthRouting(body) {
  const res = await client.put('/auth-routing', body);
  return res.data;
}
